import { render, staticRenderFns } from "./UserTweetsPosts.vue?vue&type=template&id=a489f6f8&scoped=true&"
import script from "./UserTweetsPosts.vue?vue&type=script&lang=js&"
export * from "./UserTweetsPosts.vue?vue&type=script&lang=js&"
import style0 from "./UserTweetsPosts.vue?vue&type=style&index=0&id=a489f6f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a489f6f8",
  null
  
)

export default component.exports